/** Strip HTML tags for plain-text preview (no DOM). */
export function stripHtml(html: string): string {
  if (!html) return '';
  return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
}

export function truncatePlainText(text: string, maxLen: number): string {
  const t = text.trim();
  if (t.length <= maxLen) return t;
  return `${t.slice(0, maxLen).trim()}…`;
}

/** Card line: prefer short description; else truncate full description to 120 chars. */
export function getEventCardDescriptionText(event: {
  shortDescription?: string | null;
  description?: string | null;
}): string {
  const short = event.shortDescription?.trim();
  if (short) return short;
  return truncatePlainText(stripHtml(event.description || ''), 120);
}

/** Full description for tooltip (plain text). */
export function getEventCardHoverText(event: { description?: string | null }): string {
  return stripHtml(event.description || '');
}
